import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SharedModule } from "../../shared/shared.module";
import moment from "moment";
import {
  AnalyticsRangeDialogData,
  AnalyticsRangeDialogResult,
} from "../analytics.interface";

@Component({
  selector: "app-analytics-range-dialog",
  templateUrl: "./analytics-range-dialog.component.html",
  styleUrls: ["./analytics-range-dialog.component.scss"],
  standalone: true,
  imports: [SharedModule, ReactiveFormsModule],
})
export class AnalyticsRangeDialogComponent {
  readonly dateRangeForm = new FormGroup({
    from: new FormControl<Date | null>(null),
    to: new FormControl<Date | null>(null),
  });

  constructor(
    private readonly dialogRef: MatDialogRef<
      AnalyticsRangeDialogComponent,
      AnalyticsRangeDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: AnalyticsRangeDialogData,
  ) {
    const defaultFrom = data?.from ?? moment().startOf("month").toDate();
    const defaultTo = data?.to ?? moment().endOf("day").toDate();
    this.dateRangeForm.patchValue(
      { from: defaultFrom, to: defaultTo },
      { emitEvent: false },
    );
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    const { from, to } = this.dateRangeForm.getRawValue();
    if (!from) {
      return;
    }
    this.dialogRef.close({
      from: moment(from).startOf("day").toDate(),
      to: to ? moment(to).endOf("day").toDate() : undefined,
    });
  }
}
